import './FormSkeleton.scss';

const FormSkeleton = () => {

    return (
        <>
            <div className="contact__form__skeleton">
                <div className="contact__form__row__skeleton">
                    <div className="contact__form__row__item__skeleton">
                        <div className="contact__form__input__label__skeleton">
                            <div className='input__form__skeleton'></div>
                        </div>
                        <div className="contact__form__input__label__skeleton">
                            <div className='input__form__skeleton'></div>
                        </div>
                    </div>
                    <div className="contact__form__row__item__skeleton">
                        <div className="contact__form__input__label__skeleton">
                            <div className='input__form__skeleton'></div>
                        </div>
                        <div className="contact__form__input__label__skeleton">
                            <div className='input__form__skeleton'></div>
                        </div>
                    </div>
                    <div className="contact__form__row__item__skeleton">
                        <div className="contact__form__textarea__label__skeleton">
                            <div className='input__form__textarea__skeleton'></div>
                        </div>
                    </div>
                    <div className="contact__form__row__item__skeleton">
                        <div className="contact__form__file__input__skeleton">
                            <div className='input__form__skeleton'></div>
                        </div>
                        <div className="contact__form__buttons__skeleton">
                            <div className='input__form__skeleton'></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FormSkeleton;